import * as S from "./styles.ts";
import { useTypedDispatch } from "@/redux/helpers/hooks.ts";
import { logOut } from "@/redux/slices/user/thunks/logout.ts";
import { useRouter } from "@/lib/helpers/hooks/useRouter.ts";

import { Button } from "@template/components";
import useLink from "@/lib/helpers/useLink.ts";

const UserControlDropdown = () => {
  const dispatch = useTypedDispatch();
  const router = useRouter();
  const universalLink = useLink();

  return (
    <S.DropdownContainer>
      <Button
        size="md"
        fullWidth
        onClick={() => universalLink({ href: "/account" })}
      >
        Dashboard
      </Button>
      <Button
        variant="outline"
        fullWidth
        onClick={async () => {
          dispatch(logOut()).then(() => router.push("/"));
        }}
        size="md"
      >
        Log Out
      </Button>
    </S.DropdownContainer>
  );
};

export default UserControlDropdown;
